import React, { useState } from 'react'
import WorksItems from './WorksItems'
import { projectsData, projectsNav } from './Data'

const Works = () => {
    const [filter, setFilter] = useState('all');

    const projects = filter === 'all'
        ? projectsData
        : projectsData.filter((project) => project.category === filter);

  return (
    <div>
        <div className="work_filters">
        {projectsNav.map((nav) => (
            <span
                onClick={() => setFilter(nav.name)}
                className={`${filter === nav.name ? 'active-work' : ""} work_item`}
                key={nav.name}>
                {nav.name}
            </span>
        ))}
        </div>
        <div className="work_container container grid">
            {projects.map((item) => <WorksItems item={item} key={item.id}/>)}
        </div>
    </div>
  )
}

export default Works
